import React from 'react';
import {Col, Row} from "react-materialize";
import Input from "./components/Input";
import ButtonMy from "./components/Button";

import Firebase from "firebase";

import CryptoFunction from "./functions/CryptoFunctions";
import Cookies from "universal-cookie/es6";

const cookie = new Cookies();

const dict = {
    enc: 'Зашифрованный текст:',
    dec: 'Расшифрованный текст:'
}

class MainCrypt extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            inputText: null,
            inputKey: null,
            // inputKey: null,
            inputOut: null,
            textOutDef: dict.enc
        }
    }


    editText = (e)=>{
        this.setState({
            inputText: e.target.value
        })
    }


    editKey = (e)=>{
        this.setState({
            inputKey: e.target.value
        })
    }



    encryptText = () => {
        if (this.state.inputText !== null && this.state.inputKey !== null)
            this.setState({
                inputOut: CryptoFunction.encryptDesAes(this.state.inputText, this.state.inputKey),
                textOutDef: dict.enc
            })
    }

    decryptText = () => {
        if (this.state.inputText !== null && this.state.inputKey !== null)
            this.setState({
                inputOut: CryptoFunction.decryptDesAes(this.state.inputText, this.state.inputKey),
                textOutDef: dict.dec
            })

    }


    copyOut = () => {
        window.navigator.clipboard.writeText(this.state.inputOut).then(()=>this.sayCopied());
    }

    copyText = () => {
        window.navigator.clipboard.writeText(this.state.inputText).then(()=>this.sayCopied());
    }

    copyKey = () => {
        window.navigator.clipboard.writeText(this.state.inputKey).then(()=>this.sayCopied());
    }

    pasteText = () => {
        window.navigator.clipboard.readText()
            .then((el)=>{
                console.log(el);
            })
            .catch((e)=>console.log(e))
        // this.setState({
        //     inputText: window.navigator.clipboard.readText().then((e)=>e)
        // })
    }

    pasteKey = () => {
        this.setState({
            inputKey: window.navigator.clipboard.readText()
        })
    }

    sayCopied = ()=>{
        window.M.toast({html: "Copied!"});
    }

    clearText = () =>{
        this.setState({
            inputText: null
        });
    }

    clearKey = () =>{
        this.setState({
            inputKey: null
        });
    }

    clearOut = () =>{
        this.setState({
            inputOut: null
        });
    }

    wtf = (e) => {
        //wtf
    }


    render() {
        return (
            <div className={'container'}>
                <Row>
                    <Col s={12} m={10} offset={'m1'}>
                        <h5>Основной метод (DES + AES)</h5>
                        <Input
                            text={'Текст'}
                            editInputValue={this.state.inputText}
                            editInput={this.editText}
                            onCopy={this.copyText}
                            onPaste={null} //TODO:
                            onClear={this.clearText}
                        />
                        <Input
                            text={'Ключ'}
                            editInputValue={this.state.inputKey}
                            editInput={this.editKey}
                            isKey
                            onCopy={this.copyKey}
                            onPaste={null} //TODO:
                            onClear={this.clearKey}
                        />
                        <div className={'card purple lighten-5'}>
                            <div className="card-content">
                                <ButtonMy
                                    text={'Зашифровать'}
                                    whyAreYouRunning={this.encryptText}
                                />

                                <ButtonMy
                                    text={'Расшифровать'}
                                    whyAreYouRunning={this.decryptText}
                                />

                            </div>
                        </div>

                        {/*<div className={'card red lighten-4'}>*/}
                        {/*    <div className="card-content">*/}
                        {/*        <ButtonMy*/}
                        {/*            text={'Зашифровать (Сложный алгоритм)'}*/}
                        {/*            whyAreYouRunning={this.encryptTextHard}*/}
                        {/*        />*/}

                        {/*        <ButtonMy*/}
                        {/*            text={'Расшифровать (Сложный алгоритм)'}*/}
                        {/*            whyAreYouRunning={this.decryptTextHard}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {this.state.inputOut !== null ?
                            <Input
                                text={this.state.textOutDef}
                                editInputValue={this.state.inputOut}
                                editInput={this.wtf}
                                readonly
                                onCopy={this.copyOut}
                                onPaste={null}
                                onClear={this.clearOut}

                            />
                            : null}

                     </Col>

                </Row>
            </div>
        )
    }
}

export default MainCrypt;